import { CommonModule } from '@angular/common';
import { Component, Input, NgModule, OnDestroy, OnInit, forwardRef } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

import { Subscription } from 'rxjs';

import { TranslateService } from '@codeandweb/ngx-translate';

import { DropdownModule } from '@app/primeng-overrides/dropdown';
import { AutoCompleteModule } from 'primeng/autocomplete';

import { TypeOperationModificative } from '@app/texte/texte.model';
import { ListesGeneriquesService, OperationDefinition } from '@global/listes-generiques.service';

import { ControlValueAccessorBase } from '@app/_helpers/control-value-accessor-base';

@Component({
	selector: 'operation-selector',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => OperationSelectorComponent),
			multi: true
		}
	],
	template: `
		<p-dropdown
			[name]="name"
			[required]="required"
			[options]="options"
			[(ngModel)]="value"
			[readonly]="readonly"
			[ngClass]="{'p-readonly': readonly}"
			[placeholder]="_placeholder"
			[disabled]="disabled"
			[showClear]="nullOption"
			optionValue="tot_code"
			optionLabel="tot_libelle"
			appendTo="body"
			[styleClass]="styleClass"
		>
		</p-dropdown>
	`
})
export class OperationSelectorComponent extends ControlValueAccessorBase<string> implements OnInit, OnDestroy  {

	@Input() name: string;
	@Input('value') innerValue: string;
	@Input() required: boolean;
	@Input() readonly: boolean;
	@Input() placeholder: string;
	@Input() nullIfInvalid: boolean;
	@Input() nullOption: boolean;
	@Input() disabled: boolean;
	@Input() unavailableRubriques?: number[];
	@Input() excludedValues?: TypeOperationModificative[];
	@Input() fam_id: number;
	@Input() thm_id: number;
	@Input() styleClass?: string

	_placeholder: string = 'Sélectionnez';

	options: OperationDefinition[] = [];

	subscriptionLangChange?: Subscription;

	constructor(
		private listesGeneriquesService: ListesGeneriquesService,
		private translateService: TranslateService,
	) {
		super();

		this.options = this.listesGeneriquesService.definitionsOperations;

		if (this.placeholder == undefined) {
			this.subscriptionLangChange = this.translateService.onLangChange.subscribe(() => {
				this._placeholder = translateService.instant('common.selector_placeholder');
			});
		}
	}

	ngOnInit() {
		if (this.placeholder != undefined) {
			this._placeholder = this.placeholder;
		}
		if (this.excludedValues != undefined) {
			this.options = this.options.filter((def: OperationDefinition) => !this.excludedValues!.includes(def.tot_code));
		}
	}

	ngOnDestroy(): void {
		this.subscriptionLangChange?.unsubscribe();
	}

}


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		AutoCompleteModule,
		DropdownModule
	],
	exports: [OperationSelectorComponent],
	declarations: [OperationSelectorComponent]
})
export class OperationSelectorModule { }
